// on user input, making sure keycloak login is active, to avoid losing any of the user's input.

// https://chatgpt.com/share/68ee05f1-3274-800f-a28b-af0d53ee448b

export function createActivityTracker(keycloak) {
    let active = false;
    let throttled = false;

    function refreshToken() {
        console.log("activityTracker: possibly refreshing token");
        if (!active || throttled || !keycloak?.authenticated) return;
        throttled = true;
        setTimeout(() => (throttled = false), 5000);

        console.log("activityTracker: refreshing token at", new Date());

        keycloak.checkTokenOrLogin();
    }

    function isUserInputElement(el) {
        if (!el) return false;
        const tag = el.tagName?.toLowerCase();
        const type = el.type?.toLowerCase?.();

        if (el.isContentEditable || tag === "textarea" || tag === "select" || tag === "option")
            return true;

        if (tag === "input") {
            return [
                "text","number","email","password","search","url","tel",
                "date","datetime-local","month","week","time","color","file",
            ].includes(type);
        }

        // vue-multiselect or similar custom dropdowns
        if (el.closest(".multiselect") || el.closest(".multiselect__content-wrapper") || el.closest('.ce-toolbar__settings-btn') || el.closest('.codex-editor'))
            return true;

        return false;
    }

    function onActivity(e) {
        // also for keydown, check if it's an input element
        if (e.type == "click" || e.type == "pointerdown" || e.type == "keydown") {
            if (isUserInputElement(e.target))
                refreshToken();
        } else if (e.type == 'input')
            refreshToken();
        else
            throw new Error('unexpected type', e.type);
    }

    function enableListeners() {
        if (active) return;
        active = true;

        window.addEventListener("pointerdown", onActivity, true);
        window.addEventListener("click", onActivity, true);
        window.addEventListener("keydown", onActivity, true);
        window.addEventListener("input", onActivity, true);
        // don't think I want that:
        //window.addEventListener("focusin", onActivity, true);
    }

    function disableListeners() {
        if (!active) return;
        active = false;

        window.removeEventListener("pointerdown", onActivity, true);
        window.removeEventListener("click", onActivity, true);
        window.removeEventListener("keydown", onActivity, true);
        window.removeEventListener("input", onActivity, true);
        //window.removeEventListener("focusin", onActivity, true);
    }

    return { enableListeners, disableListeners };
}

